export default "__VITE_ASSET__oX1hjsKo__"